import React from 'react'
import {Collapse} from "@material-ui/core";
import getObjectValue from "libs/getObjectValue";
import ContractNotDivided from "./ContractNotDivided";
import ContractDivided from "./ContractDivided";


function ContractData(
    {
        id,
        formikProps
    }) {

    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const partialOffers = gVal("form.orderObject.partialOffers", false)

    return (<>

        <Collapse in={partialOffers === false} unmountOnExit>
            <ContractNotDivided id={gId("notDivided")} formikProps={formikProps} />
        </Collapse>

        <Collapse in={partialOffers === true} unmountOnExit>
            <ContractDivided id={id} formikProps={formikProps}/>
        </Collapse>

    </>)
}

ContractData.propTypes = {};

export default ContractData;
